import AllApis from "app/Apis/apis";
import { ALL_PURCHASE_ORDER_FAIL, ALL_PURCHASE_ORDER_REQUEST, ALL_PURCHASE_ORDER_SUCCESS } from "app/utils/constants/purchaseOrderConstant";


import axios from "axios";
import { Axios } from "index";

export const getAllPurchaseOrders =
  (search_value, sort, sortBy, page, filters) => async (dispatch) => {
    try {
      const body = {
        filters: {
          ...filters,
        },
        searchFields: {
          string: [
            "ssk_details.supplier_name",
            "ssk_details.gst_no",
            "ssk_details.address.city",
            "ssk_details.address.state",
            "order_status",
          ],
          numbers: ["purchase_order_no","total_weight","total_amount"],
        },
      };
      if (!search_value) {
        search_value = "";
      }

      const urlParams = new URLSearchParams({
        search: search_value.trim(),
        page: page,
        sort: sort,
        sortBy: sortBy,
      });

      dispatch({ type: ALL_PURCHASE_ORDER_REQUEST });

      const data = await Axios.post(
        `${
          AllApis.purchaseOrder.list
        }?${urlParams.toString()}`,
        body
      );
      dispatch({
        type: ALL_PURCHASE_ORDER_SUCCESS,
        payload: {
          data: data?.data?.data?.purchaseOrder,
          totalPage: data?.data?.data?.totalPages,
        },
      });
    } catch (error) {
      console.log(error)
      dispatch({
        type: ALL_PURCHASE_ORDER_FAIL,
        payload: error.response.data.message,
      });
    }
  };
